module.exports = __webpack_public_path__ + "static/media/truckicon.cdd95af2.svg";